const state = {
	userInfo: {},
	test: "",
};
const mutations = {
	updateUserInfo: (state, data) => {
		state.userInfo = data;
	},
	updateTest: (state, data) => {
		state.test = data;
	},
};
const actions = {
	async getTest({ commit }, data) {
		commit("updateTest", data);
		return "success";
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
